import html_default from "./template.default.html?raw";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}

import { ref, watch, onMounted, type SetupContext } from "vue";

interface CountryEntry {
  name: string;
  code: string;   // z.B. "CH"
  dial: string;   // z.B. "+41"
  flag: string;   // Emoji-Flagge
}

interface Props {
  modelValue: string;          // internationales Format, z.B. "+41791234567"
  label?: string;
  errorMessage?: string;
}

// bei Flag sind Unicode-Zeichen hinterlegt
const COUNTRIES: CountryEntry[] = [
  { name: "Schweiz",       code: "CH", dial: "+41", flag: "🇨🇭" },
  { name: "Österreich",    code: "AT", dial: "+43", flag: "🇦🇹" },
  { name: "Deutschland",   code: "DE", dial: "+49", flag: "🇩🇪" },
  { name: "Frankreich",    code: "FR", dial: "+33", flag: "🇫🇷" },
  { name: "Italien",       code: "IT", dial: "+39", flag: "🇮🇹" },
  { name: "Spanien",       code: "ES", dial: "+34", flag: "🇪🇸" },
];

const DEFAULT_COUNTRY = COUNTRIES[0]; // CH

export default {
  template: html,
  components: {},
  emits: {
    "update:modelValue": (value: string) => typeof value === "string",
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Telefonnummer",
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },
  setup(props: Props, { emit }: SetupContext) {
    const countries = ref<CountryEntry[]>(COUNTRIES);
    const selectedCountry = ref<CountryEntry>(DEFAULT_COUNTRY);
    const localNumber = ref<string>("");

    /**
     * Parst einen gespeicherten internationalen Wert (z.B. "+41791234567")
     * und setzt selectedCountry + localNumber entsprechend.
     */
    function parseInternationalValue(value: string): void {
      if (!value) return;

      const matched = COUNTRIES.find((c) => value.startsWith(c.dial));
      if (matched) {
        selectedCountry.value = matched;
        // Lokale Nummer ohne Vorwahl, führende 0 entfernen falls vorhanden
        localNumber.value = value.slice(matched.dial.length).replace(/^0/, "");
      } else {
        localNumber.value = value;
      }
    }

    /**
     * Baut aus gewählter Vorwahl + lokaler Nummer das internationale Format
     * und emittiert es nach oben.
     */
    function emitCombined(): void {
      const raw = localNumber.value.trim().replace(/^0/, ""); // führende 0 entfernen
      const combined = raw ? `${selectedCountry.value.dial}${raw}` : "";
      emit("update:modelValue", combined);
    }

    function onInput(): void {
      emitCombined();
    }

    // Wenn sich das Land ändert, neu zusammenbauen
    watch(selectedCountry, () => {
      emitCombined();
    });

    // Wenn der Elternteil den Wert von außen setzt/ändert
    watch(
      () => props.modelValue,
      (newVal) => {
        parseInternationalValue(newVal);
      }
    );

    onMounted(() => {
      parseInternationalValue(props.modelValue);
    });

    return {
      countries,
      selectedCountry,
      localNumber,
      onInput,
    };
  },
};